import request from "./request";

const sendOtp = async (phone: string) => {
  const { data } = await request({
    url: "/v1/auth/otp",
    method: "post",
    data: { phone },
  });
  return { data };
};

const addresses = async () => {
  const res = await request({ url: "/v1/users/addresses" });
  return res.data;
};

const createAddress = async (data: any) => {
  const res = await request({
    url: "/v1/users/addresses",
    method: "post",
    data,
  });
  return res.data;
};

const updateAddress = async (uuid: string, data: any) => {
  const res = await request({
    url: `/v1/users/addresses/${uuid}`,
    method: "put",
    data,
  });
  return res.data;
};

const deleteAddress = async (uuid: string) => {
  const { data } = await request({
    url: `/v1/users/addresses/${uuid}`,
    method: "delete",
  });
  return { data };
};

const modifyFavorite = async (uuid: string) => {
  const { data } = await request({
    url: `/v1/users/favorites/${uuid}`,
    method: "post",
  });
  return { data };
};

const addFavorite = async (uuid: string) => {
  const { data } = await request({
    url: "/v1/users/favorites",
    method: "post",
    data: { menuItemUuid: uuid },
  });
  return { data };
};

const deleteFavorite = async (uuid: string) => {
  const { data } = await request({
    url: `/v1/users/favorites/${uuid}`,
    method: "delete",
  });
  return { data };
};

const login = async (data: { phone: string; code: string }) => {
  try {
    const res = await request({ url: "/auth/login", method: "post", data });
    return res.data;
  } catch (error: any) {
    if (error.status === 400) error.message = "Invalid Code";
    if (error.status === 402) error.message = "";
    throw error;
  }
};

const verifyOtp = async (payload: any) => {
  const { data } = await request({
    url: `/v1/auth/verify-otp/`,
    method: "post",
    data: payload,
  });
  return data;
};

const me = async () => {
  const res = await request({ url: "/v1/users/me" });
  return res.data;
};

const logout = async () => {
  await request({ url: "/v1/auth/logout", method: "post" });
};

const updateProfile = async ({ shortTermToken, ...data }: any) => {
  const res = await request({
    data,
    method: "put",
    url: "/v1/users/edit",
    params: { shortTermToken },
  });
  return res.data;
};

export default {
  me,
  login,
  logout,
  sendOtp,
  verifyOtp,
  addresses,
  addFavorite,
  updateProfile,
  createAddress,
  updateAddress,
  deleteAddress,
  modifyFavorite,
  deleteFavorite,
};
